import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Card } from 'react-bootstrap';
import { dateParseObject, timeFormatter } from '../../../utils';
import hotelList from '../../../utils/hotels';
import IconRoom from '../../../assets/new-icons/bed-min.png';
import { useTranslation } from 'react-i18next';


function InformationBooking() {
  const { booking } = useSelector((state) => state.booking);

  const [dateInObject, setDateInObject] = useState({
    day: '',
    month: '',
    year: '',
  });
  const [dateOutObject, setDateOutObject] = useState({
    day: '',
    month: '',
    year: '',
  });
  const [hotel, setHotel] = useState({});
  const [checkInTime, setCheckInTime] = useState('-');
  const [checkOutTime, setCheckOutTime] = useState('12:00 pm');
  const { t } = useTranslation();

  useEffect(() => {
    if (booking?.FechaEntrada) {
      setDateInObject(dateParseObject(booking.FechaEntrada));
    }

    if (booking?.FechaSalida) {
      setDateOutObject(dateParseObject(booking.FechaSalida));
    }

    if (booking?.HotelFactura) {
      // const hotel = hotelList.find((item) => item.HotelId === booking?.HotelFactura);
      setHotel(hotelList.find((item) => item.HotelId === booking?.HotelFactura));
      // console.log(hotel);
    }

    if (booking?.LlegadaHora) {
      setCheckInTime(timeFormatter(booking.LlegadaHora));
    }
  }, [booking]);

  return (
    <Card className="border-solid-1 transition-border-color border-granite-80-light">
      <Card.Body className="">
        <p className="mb-2 app-fw-notosans-bold app-fs-15 app-txt-granite-80-dark">
          {hotel.HotelName}
          {' '}
          {hotel.HotelLocation}
        </p>
        <Row>
          <Col xs={6} md={6} lg={6} xl={6} className="pe-1">
            <p className="mb-1 app-txt-gold app-fs-12 text-uppercase">Check-in</p>
            <p className="mb-1 app-txt-granite-80-dark app-fs-14">
              <span className="app-txt-gold">{dateInObject.day}</span>
              {' '}
              {dateInObject.month}
              {' '}
              {dateInObject.year}
              <span className="ps-1 text-uppercase">{checkInTime}</span>
            </p>
            <p className="mb-0 app-txt-granite-80-dark app-fw-notosans-bold app-fs-12 pt-1">
              <span className="align-sub">
                {t('TXT_RESERVATION')}
                :
                {' '}
                { booking.NumReserva }
              </span>
            </p>
          </Col>
          <Col xs={6} md={6} lg={6} xl={6} className="ps-1">
            <p className="mb-1 app-txt-gold app-fs-12 text-uppercase">Check-Out</p>
            <p className="mb-1 app-txt-granite-80-dark app-fs-14">
              <span className="app-txt-gold">{dateOutObject.day}</span>
              {' '}
              {dateOutObject.month}
              {' '}
              {dateOutObject.year}
              <span className="ps-1 text-uppercase">{checkOutTime}</span>
            </p>
            <p className="mb-0 app-txt-granite-80-dark">
              <span className="app-txt-gold app-fs-12 app-fw-segoe-bold pe-1">
                <img src={IconRoom} alt="IconRoom" className="img-fluid-3" style={{ width: '15px' }} />
              </span>
              <span className="app-fw-notosans-bold align-sub ps-1 app-fs-12">{booking.THDescripcion}</span>
            </p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default InformationBooking;
